import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ProductoService {

  constructor() {

  }

  setCurrentApp(appId: string){
    localStorage.setItem('idAplicacion', appId);
  }

  getCurrentApp(): string{
    return localStorage.getItem('idAplicacion');
  }

  setLoginParams(appId: string, filtroAdicional: string, redirectUrl: string){
    localStorage.setItem('loginParams', JSON.stringify({
      idAplicacion: appId,
      filtroAdicional,
      redirectUrl
    }));
  }

  getLoginParams(): any{
    return JSON.parse(localStorage.getItem('loginParams'));
  }

  clearLoginParams(){
    localStorage.removeItem('loginParams');
  }
}
